import React, { useState, useContext } from 'react'
import {
  Container,
  Divider,
  TextField,
  InputAdornment,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  MenuItem,
  Button,
} from '@material-ui/core'
import { BrowserView, MobileView } from 'react-device-detect'
import FlexView from 'react-flexview/lib'
import SessionContext, { SessionContextStore, SESSION_ACTIONS } from '../../context/SessionContext'
import { UserApi } from '../../api/user.api'
import { AuthApi } from '../../api/auth.api'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import './UserProfile.css'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { AddressSection } from './ProfileSections/AddressSection'
import { UserSection } from './ProfileSections/UserSection'
import { InsuranceHistorySection } from './ProfileSections/InsuranceHistorySection'
import { UserProfileContextStore } from '../../context/UserProfileContext'
import DoneIcon from '@material-ui/icons/Done'
import { isOver18, awaitWithLoading, isInPolicyManagmentFlow } from '../../services/utils'
import { useLocation } from 'react-router-dom'
import { BackButton } from '../Core/Buttons/BackButton'
import { ContinueButton } from '../Core/Buttons/ContinueButton'
import NewFillButton from '../Core/NewFillButton'
import { TextDivider } from '../Core/TextDivier'
import { SessionService } from '../../services/SessionService'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import { ERROR_CODES } from '../../models/errors/ErrorCodes'
import { useHistory } from 'react-router-dom'
import { reportGTM } from '../Core/Utilities/GTagManger'
import BrokerConfigService from '../../services/BrokerConfigService'
import { UnavailableStatePopup } from '../PopUps/UnavailableStatePopup'
import { useAdministrativeDivisions } from '../Core/Hooks/useAdministrativeDivision'
import { stateDisclaimers, statesWithoutInsuranceHistory } from '../../Constants'
import { SkyInformationPopover } from '../Core/Popover/SkyPopover'
import { BuyingInsuranceContextStore } from '../../context/BuyingInsuranceContext'

export const UserProfile = props => {
  const [showPasswordlessVerifyMsg, setShowPSVerifyMsg] = React.useState(false)
  const location = useLocation()
  const history = useHistory()
  let context = useContext(SessionContextStore)
  const profileContext = useContext(UserProfileContextStore)
  const offersContext = useContext(BuyingInsuranceContextStore)
  const registerPasswordlessEnum = {
    Success: 'success',
    SendEmail: 'sendEmail',
    Login: 'login',
  }

  const isAddressValid = () => {
    return (
      profileContext.address.address_line_1 &&
      profileContext.address.city &&
      profileContext.address.state != 'statedefault' &&
      profileContext.address.zipcode
    )
  }
  const { administrativeDivisions: inactiveStates } = useAdministrativeDivisions(false)
  const [popUpErrorState, setPopUpErrorState] = React.useState({
    title: '',
    body: '',
    showPopUp: false,
  })
  const cancelErrorPopup = () => setPopUpErrorState({ open: false, title: '', body: '' })
  const isUserInfoValid = () => {
    return profileContext.user_info.fname && profileContext.user_info.lname
  }

  const userAlreadyExistsResponse = res => {
    return res && !res.ok && res.status == 400 && res.data.code && res.data.code == ERROR_CODES.USER_ALREADY_EXISTS_ERROR
  }
  const existsPasswordlessLoginAttempt = res => {
    return res && !res.ok && res.status == 400 && res.data.code && res.data.code == ERROR_CODES.PASSWORDLESS_USER_LOGIN_ATTEMPT_ERROR
  }

  const [insuranceHistoryValid, setInsuranceHistoryValid] = useState(isAddressValid())

  const save = () => {
    EventEmitterService.dispatch(EventKey.USER_PROFILE_SAVE)
    setInsuranceHistoryValid(true)

    setTimeout(() => {
      var errElm = document.getElementsByClassName('Mui-error')

      if (errElm && errElm.length > 0) {
        var elementPosition = errElm[0].getBoundingClientRect().top
        var offsetPosition = elementPosition - 40
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        })
      }
    }, 300)
  }

  const isInProfile = location.pathname == '/account/profile'

  const warningPart1 =
    'To offer an accurate quote in connection with this application for insurance, we will use a credit-based insurance score developed by a third party based on'
  const warningPart2 = "information contained in the unit owner's credit report.  Future reports may be used to update or renew insurance."
  const warningPart3 = 'By proceeding with the quote, I confirm compliance with disclosure requirements.'
  const agreeToConditions = 'By continuing through the online portal, you agree to our '
  const termsHref = history.createHref({ pathname: 'https://www.voominsurance.com/terms-of-service' })
  const privacyHref = history.createHref({ pathname: 'https://www.voominsurance.com/privacy-policy' })
  const openTermsAndCondition = e => {
    e.preventDefault()
    window.open(termsHref.toString(), '_blank')
  }

  const openPrivacyPolicy = e => {
    e.preventDefault()
    window.open(privacyHref.toString(), '_blank')
  }
  React.useEffect(() => {
    async function uploadProfileData() {
      let registerPasswordless: registerPasswordlessEnum
      let resRegister
      if (!SessionService.isLoggedIn()) {
        resRegister = await awaitWithLoading(
          context.registerPasswordless(profileContext.user_info.email, profileContext.address.zipcode, profileContext.address.state)
        )
        window.clarityUpdateUserId(profileContext.user_info.email)
        if (resRegister.ok) {
          registerPasswordless = registerPasswordlessEnum.Success
        } else if (userAlreadyExistsResponse(resRegister) || existsPasswordlessLoginAttempt(resRegister)) {
          registerPasswordless = registerPasswordlessEnum.Login
          let res = await awaitWithLoading(
            context.passwordlessLogin(
              profileContext.user_info.email,
              profileContext.user_info.lname,
              profileContext.user_info.dob,
              profileContext.address.zipcode
            )
          )
          if (res.ok) {
            registerPasswordless = registerPasswordlessEnum.Success
          }
        } else if (
          !resRegister.ok &&
          resRegister.data &&
          resRegister.data.code == 400 &&
          resRegister.data.messages &&
          resRegister.data.messages.zipcode
        ) {
          reportGTM('', '', {
            event: 'zipcode-not-supported',
            state: profileContext.address.state,
            zipcode: profileContext.address.zipcode,
          })
          EventEmitterService.dispatch(EventKey.ShowError, resRegister)
        }
      }
      if (registerPasswordless === registerPasswordlessEnum.Success || SessionService.isLoggedIn()) {
        if (context.user.state != profileContext.address.state) {
          offersContext.resetOfferCart()
        }
        let res = await awaitWithLoading(UserApi.saveProfile(profileContext, isInPolicyManagmentFlow(location.pathname)))
        if (!res.ok) {
          if (res.data.title === 'Insurance Purchase Unavailable') {
            let message = ''
            for (const key in res.data.messages) {
              if (key === 'IsStateActive') {
                reportGTM('', '', { event: 'Ok-non-active-state' })
              }
              message += res.data.messages[key]
            }
            setPopUpErrorState({
              title: res.data.title,
              body: message,
              showPopUp: true,
            })
            context.logout()
          } else {
            EventEmitterService.dispatch(EventKey.ShowError, res)
          }
        } else {
          let paymentFlowResponse = await awaitWithLoading(UserApi.getPaymentFlow(profileContext.address.state))

          profileContext.dispatch({ type: 'RESET' })
          if (res.ok && paymentFlowResponse.ok) {
            reportGTM('', '', { event: 'successful-profile-saved' })
            context.dispatch({ type: SESSION_ACTIONS.UPDATE_USER_PROFILE, data: res.parsedData })
            context.dispatch({ type: SESSION_ACTIONS.UPDATE_USER_PAYMENT_FLOW, data: paymentFlowResponse.parsedData })
            if (location.pathname == '/insurance/profile') EventEmitterService.dispatch(EventKey.FLOW_PROFILE_FINISH, res.parsedData)
            else if (location.pathname == '/account/profile') {
              EventEmitterService.dispatch(EventKey.ShowSuccess, { title: 'Profile saved successfully' })
            } else EventEmitterService.dispatch(EventKey.ShowSuccess, { title: 'Success!', body: 'Your details were sent to your broker' })
          } else EventEmitterService.dispatch(EventKey.ShowError, res)
        }
      } else {
        switch (registerPasswordless) {
          case registerPasswordlessEnum.SendEmail:
            setShowPSVerifyMsg(true)
            break
          case registerPasswordlessEnum.Login:
            resRegister.data.title = 'You are already registered'
            EventEmitterService.dispatch(EventKey.ShowError, {
              res: resRegister,
              actionText: 'Login to Continue',
              onClose: () => {
                history.push('/login')
              },
            })
            break
          default:
            EventEmitterService.dispatch(EventKey.ShowError, resRegister)
            break
        }
      }
    }
    if (
      profileContext.user_info_saved &&
      profileContext.insurance_history_saved &&
      profileContext.address_saved &&
      isUserInfoValid() &&
      isAddressValid()
    ) {
      uploadProfileData()
    }
  }, [profileContext.user_info_saved, profileContext.insurance_history_saved, profileContext.address_saved, profileContext.address.zipcode])

  return showPasswordlessVerifyMsg ? (
    <FlexView column hAlignContent={'center'}>
      <MailOutlineIcon className="x-large-icon blue" />
      <br />
      <div className="text-body textcenter">A link to verify your email has been sent to {profileContext.user_info.email}</div>
      <br />
      <div className="texy-body textcenter bold">Please check your email to continue</div>
      <br />
      <button onClick={() => history.push('/login')} className="texy-body textcenter bold">
        Go to login
      </button>
    </FlexView>
  ) : (
    <React.Fragment>
      <BrowserView>
        <Container className="margin-top-medium">
          <UserSection />
          <Divider />
          <div className="text-small-title black bold">Physical Address</div>
          <AddressSection />
          <Divider />
          {context.isActiveState && !statesWithoutInsuranceHistory.includes(context.selectedState) && (
            <span>
              {' '}
              <div className="text-small-title black bold">Insurance History</div>
              <InsuranceHistorySection />
              <Divider />{' '}
            </span>
          )}
          <div className="gray avenir-book">
            {context.selectedState && stateDisclaimers[context.selectedState] && <div>{stateDisclaimers[context.selectedState]}</div>}
            <br />
            {warningPart1}
            <br />
            {warningPart2}
            <br />
            {warningPart3}
          </div>
          <br />
          {location.pathname == '/insurance/profile' && (
            <FlexView className="margin-top-small margin-bottom-basic">
              {/* <BackButton /> */}
              <ContinueButton onClick={save} />
            </FlexView>
          )}
          <div className="grey">
            {agreeToConditions}
            <span onClick={openTermsAndCondition} className="bold clickable underline">
              Terms and Conditions
            </span>{' '}
            and{' '}
            <span onClick={openPrivacyPolicy} className="bold clickable underline">
              Privacy Policy
            </span>
            <br />
          </div>
          {isInProfile && (
            <FlexView className="margin-top-small margin-bottom-basic">
              <NewFillButton onClick={save}>Save Changes</NewFillButton>
            </FlexView>
          )}
        </Container>
      </BrowserView>
      <MobileView>
        <Container maxWidth="lg" className="margin-top-medium">
          <div className="margin-top-medium margin-bottom-medium">
            <TextDivider>
              <div className="text-title bold blue">Owner Details</div>
            </TextDivider>
          </div>
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <div className="text-title bold black">Personal Details</div>
              {isUserInfoValid() && <DoneIcon className="green margin-left-6" />}
            </AccordionSummary>
            <AccordionDetails>
              <UserSection />
            </AccordionDetails>
          </Accordion>
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <div className="text-title bold black">Physical Address</div>
              {isAddressValid() && <DoneIcon className="green margin-left-6" />}
            </AccordionSummary>
            <AccordionDetails>
              <AddressSection />
            </AccordionDetails>
          </Accordion>
          {context.isActiveState && !statesWithoutInsuranceHistory.includes(context.selectedState) && (
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <div className="text-title bold black">Insurance History</div>
                {insuranceHistoryValid && <DoneIcon className="green margin-left-6" />}
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <InsuranceHistorySection />
                </div>
              </AccordionDetails>
            </Accordion>
          )}
          <div className="gray footer-text">
            {context.selectedState && stateDisclaimers[context.selectedState] && <div>{stateDisclaimers[context.selectedState]}</div>}
            <br />
            {warningPart1} {warningPart2} {warningPart3}
          </div>
        </Container>
        {location.pathname == '/insurance/profile' && (
          <>
            <FlexView className="margin-top-basic" hAlignContent={'right'}>
              <ContinueButton onClick={save} />
            </FlexView>
          </>
        )}
        {isInProfile && (
          <FlexView hAlignContent={'center'} className="margin-top-small margin-bottom-basic">
            <NewFillButton onClick={save}>Save Changes</NewFillButton>
          </FlexView>
        )}
      </MobileView>
      <UnavailableStatePopup
        title={popUpErrorState.title}
        body={popUpErrorState.body}
        open={popUpErrorState.showPopUp}
        onCancel={cancelErrorPopup}
      />
    </React.Fragment>
  )
}
